import { createQueryKeys } from '@lukemorales/query-key-factory';

import type { DemandDefinitionInput } from '../../../demand-definition/types/DemandDefinitionInput';
import {
    calculateDemand,
    getDemandDefinition,
    getDemandDefinitionFleet,
    getDemandDefinitions,
} from '../clients/demandDefinitions.api';
import type { GetDemandDefinitionFleetParams, GetDemandDefinitionsParams } from '../clients/demandDefinitions.api';

export const demandDefinitions = createQueryKeys('demandDefinitions', {
    list: (params: GetDemandDefinitionsParams) => ({
        queryKey: [{ params }],
        queryFn: () => getDemandDefinitions(params),
    }),
    detail: (id: string) => ({
        queryKey: [id],
        queryFn: () => getDemandDefinition(id),
    }),
    fleet: (params: GetDemandDefinitionFleetParams) => ({
        queryKey: [params],
        queryFn: () => getDemandDefinitionFleet(params),
    }),
    calculation: (input: DemandDefinitionInput, customerGroupId?: string, definitionId?: string) => ({
        queryKey: [input, { customerGroupId, definitionId }],
        queryFn: () => calculateDemand(input, customerGroupId, definitionId),
    }),
});
